module.exports = __webpack_public_path__ + "assets/icon_pillars.700983a4.svg";